<!--  -->
<template>
  <div>
    <div class="head">
      <div class="head-layout">
        <img
          src="https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202103/338d8c90612041e4b6059d71dd8504a8.jpg"
          
        />
        <span style="color: #fff; font-size: 26px; margin-left: 10px">{{
          name
        }}</span>
      </div>
    </div>
    <div class="layout">
      <div class="" style="min-height: 80px">
        <div style="position: relative">
          <!-- <Breadcrumb>
            <BreadcrumbItem>首页</BreadcrumbItem>
            <BreadcrumbItem>管理</BreadcrumbItem>
            <BreadcrumbItem>证件申请</BreadcrumbItem>
          </Breadcrumb> -->
          <div class="header-tool-title">证件导入/{{ bageType }}</div>
          <div class="back" @click="back">返回首页</div>
        </div>
      </div>
    </div>
    <div class="body">
      <span style="font-size: 20px">说明：</span>请<span style="color: red"
        >
        下载模板
        </span
      >收集信息,以保证数据上传成功
      <div style="padding: 20px 0">
        <!-- <Button
          style="
            text-decoration: none;
            margin-bottom: 10px;
            display: inline-block;
            color: #57a3f3;
          "
          
          > -->
         <a href="http://edm.synair.cn/fibo/批量上传模板-海外及港澳台.xlsx" download="批量上传模板-海外及港澳台.xlsx" v-if="BadgeId&&BadgeId==3" class="aButton">下载模板</a>
         <a href="http://edm.synair.cn/fibo/批量上传模板-展商证、特邀嘉宾.xlsx" download="批量上传模板-展商证、特邀嘉宾.xlsx" v-if="BadgeId&&BadgeId!=3" class="aButton">下载模板</a>
          <!-- </Button
        > -->
        
        <p style="color: red; margin-top:10px">
          注意事项：<br />
          1. 下载的模板为Excel表格,可用Office或WPS打开<br />
          2. 请勿更改Excel格式，模板中的表头不可更改，不可删除<br />
          3. 请确认上传的文件格式为(.xlsx)文件小于2M<br />
          4. 请务必检查您的公司名称、展位号与合同中的信息一致
        </p>
      </div>
      <div style="padding-bottom: 20px">
        <Upload
          ref="upload"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          :format="['xls', 'xlsx']"
          :headers="formHeaders"
          :on-format-error="handleFormatError"
          :before-upload="handleBeforeUpload"
          :action="uploadUrl"
          style="padding-top: 10px"
        >
          <Button icon="ios-cloud-upload-outline"
            >导入展商</Button
          >
         
        </Upload>
         
      </div>
      <a href="http://yanshi-center.huizhanren.cn/exhibition/login/alogin" target="view_window" style="display: inline-block;">登录展商中心查看上传信息</a>
      <div class="submit" @click="submit()">提交</div>
    </div>
  </div>
</template>

<script>
import config from '@assets/config.json';
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      uploadUrl: `${config.api.reqApi}/api/upload/files`,
      formHeaders: {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      },
      uploadList: [],
      uploadPath: "",
      uploading: false,
      tHeader: [],
      name: "",
      bageType: "",
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.init();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  computed: {
    ...mapGetters({}),
    exhibitionId() {
      return this.$route.query.exhibitionId;
    },
    BadgeId() {
      return this.$route.query.BadgeId;
    },
  },
  methods: {
    ...mapActions({
      getExhibitionByIdNew:"exhibitionModule/getExhibitionByIdNew"
    }),
    async init() {
      if (this.BadgeId == 1) {
        this.bageType = "展商证";
      }
      if (this.BadgeId == 2) {
        this.bageType = "特邀嘉宾";
      }
      if (this.BadgeId == 3) {
        this.bageType = "海外/港澳台认证";
      }
      if (this.BadgeId == 4) {
        this.bageType = "VIP";
      }
      let data = await this.getExhibitionByIdNew(this.exhibitionId);
      if (data.name) {
        this.name = data.name;
      }
      localStorage.setItem("uploadPath", "");
    },
    // 上传成功
    handleSuccess(res, file) {
      this.uploading = false;
      console.log(res);
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
        this.uploadPath = file.url;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式错误，请导入excel文件`);
      // this.loading = false;
    },
    handleBeforeUpload(file) {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`一次最多上传${limitNum}个文件`);
        this.uploading = true;
      }
      return check;
    },
    handleRemove() {
      console.log("删除了文件");
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList = [];
      this.uploadPath = "";
      this.uploadList = [];
    },
    // 下载模板
    exportTemplate() {
      console.log(this.BadgeId, "123");
      require.ensure([], () => {
        const {
          export_json_to_excel,
        } = require("../../../../../assets/js/Export2Excel"); //这个地址和页面的位置相关，这个地址是Export2Excel.js相对于页面的相对位置
        if (this.BadgeId != 3) {
          this.tHeader = [
            "证件类型",
            "公司名称",
            "展位号",
            "姓名",
            "电话",
            "邮箱",
            "职务",
          ];
        } else {
          this.tHeader = [
            "证件类型",
            "公司名称",
            "展位号",
            "姓名",
            "电话",
            "邮箱",
            "职务",
            "国家",
            "部门",
          ];
        }
        // 表头
        const tBody = [[]]; // 内容
        export_json_to_excel(this.tHeader, tBody, "展商导入模板"); //列表excel  这个是导出表单的名称
      });
    },
    back() {
      this.$router.go(-1);
    },
    submit() {
      if (this.uploadPath) {
        localStorage.setItem("uploadPath", this.uploadPath);
        this.$router.push(
          "/exhibition/exportTable?BadgeId=" +
            this.BadgeId +
            "&exhibitionId=" +
            this.exhibitionId
        );
      }else{
          this.$Message.error('请上传个文件')
      }
    },
  },
};
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
.head {
  
  height: 100px;
  background: #333;
  &-layout {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 100px;
    img {
      width: 70px;
      height: 70px;
    }
  }
}
.layout {
  margin: 0 auto;
  max-width: 1200px;
}
.header-tool {
}
.back {
  position: absolute;
  right: 20px;
  top: 10px;
  cursor: pointer;
  padding: 5px 10px;

  background: #fff;
}
.body {
  background: #fff;
  margin: 0 auto;
  max-width: 1200px;
  height: 450px;
  padding: 30px;
}
.submit {
  margin-top: 30px;
  width: 150px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: red;
}
.aButton{
    border:1px solid #dcdee2;
    height: 64px;
    padding: 5px 15px;
    font-size: 14px;
    border-radius: 4px;
    line-height: 1.5;
    margin-bottom: 10px;
}
</style>